import { useLazyQuery } from '@apollo/client';
export function usePaginatedAppGrid(_ref) {
  let {
    query,
    parseResponse
  } = _ref;
  const [fetchInitialApps, {
    data,
    error,
    loading,
    fetchMore: fetchMoreApps
  }] = useLazyQuery(query, {
    errorPolicy: 'all',
    notifyOnNetworkStatusChange: true
  });
  const {
    appList,
    hasNextPage,
    totalCount
  } = parseResponse(data);
  const isLoading = loading && appList.length === 0;
  const isLoadingMore = loading && appList.length !== 0;
  const showLoadMore = !error && hasNextPage;
  const showEndReached = !hasNextPage && appList.length !== 0;
  return {
    appList,
    totalCount,
    isLoading,
    isLoadingMore,
    showEndReached,
    showLoadMore,
    fetchInitialApps,
    fetchMoreApps,
    rawData: data,
    error
  };
}